module.exports = __webpack_public_path__ + "static/media/text.340e503f.svg";